import React, { useEffect, useState } from "react";
import * as httpClient from "../../../util/httpClient";
import { useForm } from "react-hook-form";
import { PATTERNS } from "../../../util/patterns";
import BillingAddress from "./BillingAddress";
import Cart from "../Cart";
import { updateState, states } from "../StateManagement";
import { DialogComponent } from "../../common/DialogComponent";
import EFTDialog from "../../Dialogs/EFTDialog";
import TermsAndConditionDialog from "../../Dialogs/T&CDialog";
import parse, { domToReact } from "html-react-parser";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import * as ConfigurationActions from "../../../store/configurationService/actions";
import { useDebounce } from "../../../util/Debounce";
import BillingSecurityNote from "./BillingSecurityNote";
import LegalDocumentContainer from "../../LegalDocumentPages/LegalDocumentContainer";
import { useTranslation } from "react-i18next";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";
import { validateCardExpiry } from "../../../util/common";
import { stateDisclosureAPI } from "../../../components/Dialogs/protectionPlan/GetStateLegalDisclaimer";
import { useButtonText } from "../../commonConstants";

interface IProps {
    displayData: any;
    manageState: any;
    registrationState: any;
    setRegistrationState: any;
    registrationLookup?: any;
}

interface IState {
    EFTData: any;
    TermsData: any;
    paymentMethod: string;
    isEFTChecked: boolean;
    isTermsChecked: boolean;
    isSameAddress: boolean;
}

interface IRegOptions {
    routingOptions: string[];
    accountOptions: string[];
}

interface IReadOnly {
    isBankNameReadOnly: boolean;
    isRoutingReadOnly: boolean;
    isAccountTypeReadOnly: boolean;
}

const BillingInformation = ({ displayData, manageState, setRegistrationState, registrationState, registrationLookup }: IProps) => {
    const { t: tLang } = useTranslation();
    const { register, unregister, handleSubmit, errors, watch, trigger, getValues, setValue } = useForm({
        mode: "onBlur",
    });
    const { getTermsOfUseURL, getPrivacyNoticeURL, getPrivacyNoticeLinkText, getTermsOfUseLinkText } = LegalDocumentContainer();
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    let history = useHistory();
    const dispatch = useDispatch();
    const address1Debounce = useDebounce(watch("address1"), 1500);
    const address2Debounce = useDebounce(watch("address2"), 1500);
    const cityDebounce = useDebounce(watch("city"), 1500);
    const zipcodeDebounce = useDebounce(watch("zipcode"), 1500);
    const LookupType = query.get("Type");
    const watchCardType = watch("cardType");
    const hasSontiqBrand = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.hasSontiqBrand
            ? state.configurationState.configuration.partnerConfig.hasSontiqBrand === "true"
                ? true
                : false
            : false
    );
    const [saleTaxValue, setSaleTaxValue] = useState(0);
    const [annualSalesTaxValue, setAnnualSalesTaxValue] = useState(0);
    const [EFTdialog, setEFTDialog] = useState(false);
    const [Termsdialog, setTermsDialog] = useState(false);
    const [isSalesTaxLoading, setIsSalesTaxLoading] = useState(false);
    const [nonCredit, setNonCredit] = useState("");
    const partnerPhoneNumber = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );
    const SubType = query.get("SUBTYPE");
    let selectedCycle = registrationState.PaymentMode.SubscriptionType
        ? registrationState.PaymentMode.SubscriptionType
        : SubType === "ANNUAL"
            ? "annual"
            : "monthly";
    let price: any;
    if (LookupType === "SSSOFFER" && displayData["billingOptions"] && displayData["billingOptions"].cartPrice) {
        price = selectedCycle
            ? selectedCycle === "annual"
                ? displayData["packageLookup"].packagDetails[0].yearlySubscriptionPrice
                : displayData["packageLookup"].packagDetails[0].monthlySubscriptionPrice
            : displayData["billingOptions"]?.cartPrice?.discountedPackagePrice;
    } else {
        price =
            selectedCycle === "annual"
                ? displayData?.billingOptions?.cartPrice?.annualPrice
                : displayData?.billingOptions?.cartPrice?.monthlyPrice;
    }
    price = parseFloat(price);
    price = price ? price.toFixed(2) : "";
    const getTnc = (prevClick: boolean) => {       
        httpClient
            .sendRequest("POST", "web/termsandcondition/get-terms-and-conditions", {
                billingPrice: parseFloat(price),
                SubscriptionType: registrationState.PaymentMode.SubscriptionType === "annual" ? "year" : "month",
                IsPreviousbtnClick: prevClick,
            })
            .then((data: any) => {
                if (data["hasError"]) {
                    if (data && data.status) {
                        switch (data.status) {
                            case "INTERNAL_ERROR":
                                history.push("/register/error");
                                break;
                            default:
                                history.push("/register/error");
                                break;
                        }
                    } else {
                        history.push("/register/error");
                    }
                }

                httpClient.sendRequest("POST", "web/partner/get-eft", {}).then((eftdata: any) => {
                    if (eftdata["hasError"]) {
                        if (eftdata && eftdata.status) {
                            switch (eftdata.status) {
                                case "INTERNAL_ERROR":
                                    history.push("/register/error");
                                    break;
                                default:
                                    history.push("/register/error");
                                    break;
                            }
                        } else {
                            history.push("/register/error");
                        }
                        return;
                    }
                    setState({ ...state, EFTData: eftdata, TermsData: data });
                });
            });
    };
    const onBillingInfoNext = (event: any) => {
        window.addToDataLayer({ event: "Agree and Continue Button Clicked" });
        if (LookupType === "SSSOFFER" || LookupType === "WALKUP") {
            let proofInfo = registrationState.proofInfo;
            let prooftime = new Date().toISOString().replace(/T/, ' ').replace(/\..+/, '');
            proofInfo.automaticRenewalTermsAcceptance = prooftime;
            setRegistrationState({ ...registrationState, proofInfo: proofInfo });
        }
    };
    
    let disclaimerType = "STATE";
    let countryValue = registrationState.addressInfo && registrationState.addressInfo.country;
    let selectedState = registrationState.addressInfo && registrationState.addressInfo.state;
    const [showDisclosure, setShowDisclosure] = useState(false);
    const [creditDisclosureText, setCreditDisclosureText] = useState("");
    const isPreviousOrBack = useButtonText()[1];
    const Gndrll: any = query.get("GNDNRLL");
    const IsWhiteLabeled: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.isWhiteLabeled
            ? state.configurationState.configuration.partnerConfig.isWhiteLabeled
            : false
    );
    let partnerId: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId
            : null
    );

    let RetailerCode: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.retailerCode
            ? state.configurationState.configuration.partnerConfig.retailerCode
            : null
    );

    let productService: string = "";
    const NonCreditServiceType = (nonCreditType: any) => {
        nonCreditType ? setNonCredit(nonCreditType) : "";
    }

    const getproductServiceType = (value: boolean) => {
        setShowDisclosure(value);
        productService = value ? "CREDIT" : nonCredit;
    };

    useEffect(() => {
        let isPreviousbtnClick = false;
        if (states[1].previous === "PersonalInformation") {
            isPreviousbtnClick = true;
        }
        getTnc(isPreviousbtnClick);
    }, [registrationState.PaymentMode.SubscriptionType]);

    useEffect(() => {
        const getDisclosureText = async () => {
            if ( countryValue === "US" && LookupType !== "PROVISIONAL") {
                let result: any = await stateDisclosureAPI(selectedState,
                    disclaimerType, productService,
                    partnerId, RetailerCode, null, null);
                return result
            }
        }
        getDisclosureText().then((value: any) => setCreditDisclosureText(value));
    }, [showDisclosure, showDisclosure===false, creditDisclosureText]);

    const [eftField, setEFTFields] = useState({
        bankName:
            registrationState.billingInfo && registrationState.billingInfo.bankName ? registrationState.billingInfo && registrationState.billingInfo.bankName : "",
        accountType: registrationState.billingInfo && registrationState.billingInfo.accountType ? registrationState.billingInfo.accountType : "",
        routingNumber: registrationState.billingInfo && registrationState.billingInfo.routingNumber ? registrationState.billingInfo.routingNumber : "",
    });

    const [regOptions, setOptions] = useState<IRegOptions>({ routingOptions: [], accountOptions: [] });
    const [isReadOnly, setIsReadOnly] = useState<IReadOnly>({ isBankNameReadOnly: false, isRoutingReadOnly: false, isAccountTypeReadOnly: false });
    const [state, setState] = useState<IState>({
        EFTData: [],
        TermsData: {},
        isSameAddress: registrationState.billingInfo && registrationState.billingInfo.isSameAddress ? registrationState.billingInfo.isSameAddress : false,
        paymentMethod: registrationState.billingInfo && registrationState.billingInfo.paymentMethod ? registrationState.billingInfo.paymentMethod : "CC",
        isEFTChecked: registrationState.billingInfo && registrationState.billingInfo.isEFTChecked ? registrationState.billingInfo.isEFTChecked : false,
        isTermsChecked: registrationState.billingInfo && registrationState.billingInfo.isTermsChecked ? registrationState.billingInfo.isTermsChecked : false,
    });
    const handleStateChange = (e: any) => {
        getSaleTaxValue(e.target.value);
    };
    const handleCloseEFTDialog = (): any => {
        setEFTDialog(false);
    };
    const handlePaymentMethod = () => {
        let { eft } = displayData.billingOptions && displayData.billingOptions.paymentOptions;
        if (eft !== null && eft.routingNumber !== null) {
            setOptions({ ...regOptions, routingOptions: eft.routingNumber.options });
        }
        if (eft !== null && eft.accountType !== null) {
            if (eft.accountType.options.length === 1) {
                setEFTFields((prevState) => ({ ...prevState, accountType: eft.accountType.selection }));
                setIsReadOnly((prevState) => ({ ...prevState, isAccountTypeReadOnly: eft.accountType.readOnly }));
            } else {
                setOptions({ ...regOptions, accountOptions: eft.accountType.options });
            }
        }
        if (eft !== null && eft.bankName !== null) {
            setEFTFields((prevState) => ({ ...prevState, bankName: eft.bankName.selection }));
            setIsReadOnly((prevState) => ({ ...prevState, isBankNameReadOnly: eft.bankName.readOnly }));
        }
    };

    const handleCloseTermsDialog = (): any => {
        setTermsDialog(false);
    };

    const isDisabled = () => {
        if (isSalesTaxLoading) {
            return isSalesTaxLoading;
        }
        if (state.paymentMethod === "EFT") {
            return !(state.isEFTChecked && state.isTermsChecked);
        }
        return !state.isTermsChecked;
    };

    const validation = {
        invalid: (val: any) => {
            if (watchCardType === "AMERICANEXPRESS") {
                return /^$|^(\d{15})$/.test(val);
            }
            return /^$|^(\d{16})$/.test(val);
        },
    };

    const validationCode = {
        invalid: (val: any) => {
            if (watchCardType === "AMERICANEXPRESS") {
                return /^[0-9]{4}$/.test(val);
            }
            return /^[0-9]{3}$/.test(val);
        },
    };

    const triggerFields = () => {
        if (getValues("cardNumber") && getValues("cardNumber").length > 0) {
            trigger("cardNumber");
        }
        setValue("securityCode", "");
    };

    const options = {
        replace: ({ attribs, children }: any) => {
            if (!attribs) return;
            if (attribs.hasOwnProperty("href")) {
                if (attribs.href.indexOf("TermsAndConditions") !== -1) {
                    return hasSontiqBrand ? (
                        <a href="https://www.sontiq.com/terms-of-use/" target="_blank">
                            {domToReact(children, options)}
                        </a>
                    ) : (
                        <a href={getTermsOfUseURL()} target="_blank">
                                {getTermsOfUseLinkText()}                            
                        </a>
                    );
                }

                if (attribs.href && attribs.href.indexOf("privacy-policy") !== -1) {
                    return <a href={getPrivacyNoticeURL()}>{getPrivacyNoticeLinkText()}</a>;
                }
            }
        },
    };

    let keyPressed: number;
    const keyCode = (e: any) => {
        keyPressed = e.keyCode;
    };
    const addMask = (e: any) => {
        e.preventDefault();
        if (e.target.value.length === 2 && keyPressed !== 8 && keyPressed !== 46) {
            e.target.value = e.target.value + "/";
        }
    };

    const setPrevious = () => {
        states[1].previous = "PersonalInformation";
        manageState(updateState(states, displayData.billingRequired, 1));
    };

    const checked = () => {
        if (state.isEFTChecked) {
            setState({ ...state, isEFTChecked: false });
            return;
        }
        setState({ ...state, isEFTChecked: true });
    };

    const checkedTerms = () => {
        if (state.isTermsChecked) {
            setState({ ...state, isTermsChecked: false });
            return;
        }
        setState({ ...state, isTermsChecked: true });
    };

    const onAutoRenewalCheckBox = (event: any) => {
        window.addToDataLayer({ event: "Clicked on I agree checkbox" });
        if ((LookupType === "SSSOFFER" || LookupType === "WALKUP") && !state.isTermsChecked) {
            let proofInfo = registrationState.proofInfo;
            let prooftime = new Date().toISOString().replace(/T/, ' ').replace(/\..+/, '');
            proofInfo.automaticRenewal = prooftime;
            setRegistrationState({ ...registrationState, proofInfo: proofInfo });
        }
    };

    const onSubmit = (data: any) => {
        data.isTermsChecked = state.isTermsChecked;
        data.isEFTChecked = state.isEFTChecked;
        data.isSameAddress = state.isSameAddress;
        setRegistrationState({ ...registrationState, billingInfo: data });
        manageState(updateState(states, displayData.billingRequired, 3));
        window.addToDataLayer({ event: "Submit BillingInformation" });
    };

    const handleChange = (e: any) => {
        setState({
            ...state,
            [e.target.name]: e.target.value,
        });
    };

    const renderError = (name: string, type: string, message: string) => {
        if (errors[name]) {
            return errors[name].type === type && <span className="form-error" role="alert">{message}</span>;
        }
        return null;
    };

    const getSaleTaxValue = (stateVal?: string) => {
        let reqData = {
            country: registrationState.addressInfo.country,
            region: stateVal ? stateVal : getValues("state"),
            city: cityDebounce,
            postalCode: zipcodeDebounce,
            street1: address1Debounce,
            street2: address2Debounce,
            subscriptionType:
                registrationState.PaymentMode && registrationState.PaymentMode.SubscriptionType
                    ? registrationState.PaymentMode.SubscriptionType.toUpperCase()
                    : "MONTHLY",
        };
        if (state.isSameAddress) {
            reqData.region = registrationState.addressInfo.state;
            reqData.city = registrationState.addressInfo.city;
            reqData.postalCode = registrationState.addressInfo.zipcode;
            reqData.street1 = registrationState.addressInfo.address1;
            reqData.street2 = registrationState.addressInfo.address2;
        }
        setIsSalesTaxLoading(true);
        httpClient.sendRequest("POST", "web/Registration/Calculate-Sales-Tax", reqData).then((data) => {
            setIsSalesTaxLoading(false);
            if (data.isSuccess) {
                getTnc(false);
                setSaleTaxValue(data.salesTax);
                if (data.annualSalesTax) {
                    setAnnualSalesTaxValue(data.annualSalesTax);
                }
                dispatch(ConfigurationActions.actionCreators.setSalesTaxData(data.salesTax, data.annualSalesTax));
                unregister("billingAddress");
            }
            if (!data.isSuccess) {
                register("billingAddress", { required: true });
            }
        });
    };

    let isOnlyCc = (registrationState.billingInfo && registrationState.billingInfo.paymentMethod === "CC") || false;
    let isOnlyEft = (registrationState.billingInfo && registrationState.billingInfo.paymentMethod === "EFT") || false;

    useEffect(() => {
        window.scrollTo(0, 0);
        handlePaymentMethod();
        register("billingAddress", { required: true });
    }, []);

    useEffect(() => {
        let defaultState = state.isSameAddress
            ? registrationState.addressInfo.state
            : registrationState.billingInfo && registrationState.billingInfo.state
            ? registrationState.billingInfo.state
            : "";
        if (defaultState) {
            getSaleTaxValue(defaultState);
        }
    }, [state.isSameAddress, registrationState.PaymentMode]);
    useEffect(() => {
        if (!state.isSameAddress && address1Debounce && cityDebounce && zipcodeDebounce) {
            getSaleTaxValue();
        }
    }, [address1Debounce, address2Debounce, cityDebounce, zipcodeDebounce, registrationState.PaymentMode]);
    return (
        <>
            <div className="box-header">
                <div className="box-title-container">
                    <div className="box-title-icon" aria-hidden="true">
                        <RenderIcons iconName="coins" />
                    </div>
                    <div className="box-title-text">
                        <h2 className="box-title">{tLang("registration.billing.title")}</h2>
                    </div>
                </div>
            </div>
            <div className="box-content">
                <form onSubmit={handleSubmit(onSubmit)} id="register-personal-info-1">
                    <div className="row between-sm">
                        <div className="col-xs-12 col-sm-7 col-no-gutter">
                            <BillingSecurityNote />
                            <div className="margin-bottom-l"></div>

                            <fieldset className="form-row inline">
                                <div className="row">
                                    <div className="col-xs-12 col-sm-4 col-no-gutter">
                                        <legend className="legend-label">  <label htmlFor="payment-method-credit">{tLang("registration.billing.info.payment-method")}</label></legend>
                                    </div>

                                    <div className="col-xs-12 col-sm-8 col-no-gutter">
                                        {!isOnlyEft && (
                                            <div className={`form-row row`}>
                                                <label className="form-radio-label">
                                                    <input
                                                        type="radio"
                                                        id="payment-method-credit"
                                                        name="paymentMethod"
                                                        ref={register({ required: true })}
                                                        onClick={(e: any) => handleChange(e)}
                                                        value="CC"
                                                        checked={state.paymentMethod === "CC"}
                                                    />
                                                    <span className="form-radio-label-text">{tLang("registration.billing.info.credit-card")}</span>
                                                </label>
                                            </div>
                                        )}
                                        {!isOnlyCc && (
                                            <div className={`form-row row`}>
                                                <label className="form-radio-label">
                                                    <input
                                                        type="radio"
                                                        id="payment-method-EFT"
                                                        name="paymentMethod"
                                                        ref={register({ required: true })}
                                                        onClick={(e: any) => handleChange(e)}
                                                        value="EFT"
                                                        checked={state.paymentMethod === "EFT"}
                                                    />
                                                    <span className="form-radio-label-text">{tLang("registration.billing.info.electronic-funds-transfer")}</span>
                                                </label>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </fieldset>
                            {displayData &&
                                displayData.billingOptions &&
                                displayData.billingOptions.paymentOptions &&
                                displayData.billingOptions.paymentOptions.customMessage && (
                                    <>
                                        <fieldset className="form-row inline">
                                            <div className="row">
                                                <div
                                                    className="required"
                                                    dangerouslySetInnerHTML={{ __html: displayData.billingOptions.paymentOptions.customMessage }}
                                                ></div>
                                            </div>
                                        </fieldset>
                                        <div className="margin-bottom-m"></div>
                                    </>
                                )}

                            {!isOnlyCc && state.paymentMethod === "EFT" && (
                                <div aria-live="off">
                                    <fieldset className="form-row inline">
                                        <div className="row" >
                                            <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                <legend className="legend-label"> <label htmlFor="label-account-name">{tLang("registration.billing.info.name-on-account")}</label>
                                                    <span className="required" title="Mandatory">
                                                        {" "}
                                                        *
                                                    </span>
                                                </legend>
                                            </div>

                                            <div className="col-xs-12 col-sm-8 col-no-gutter">
                                                <div className="row">
                                                    <div className="col-xs-12 col-no-gutter">
                                                        <div className={`form-row row ${errors["accountName"] && "status-error"}`}>
                                                            <div className="form-input col-xs-12 col-no-gutter">
                                                                <input
                                                                    type="text"
                                                                    className="inputbox"
                                                                    id="label-account-name"
                                                                    placeholder={tLang("registration.billing.info.name-on-account")}
                                                                    ref={register({ required: true, pattern: /^[a-zA-Z-'\s.]+$/, maxLength: 30 })}
                                                                    name="accountName"
                                                                    defaultValue={
                                                                        Object.keys(registrationState.billingInfo).length !== 0
                                                                            ? registrationState.billingInfo.accountName
                                                                            : null
                                                                    }
                                                                    aria-required="true"
                                                                />
                                                                {errors["accountName"] && errors["accountName"].type === "required" && (
                                                                    <span className="form-error" role="alert">
                                                                        {tLang("registration.billing.info.validations.name-on-account-required")}
                                                                    </span>
                                                                )}
                                                                {errors["accountName"] && errors["accountName"].type === "pattern" && (
                                                                    <span className="form-error" role="alert">
                                                                        {tLang("registration.billing.info.validations.name-on-account-invalid")}
                                                                    </span>
                                                                )}
                                                                {errors["accountName"] && errors["accountName"].type === "maxLength" && (
                                                                    <span className="form-error" role="alert">
                                                                        {tLang("registration.billing.info.validations.name-on-account-invalid-max-length")}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </fieldset>
                                    <fieldset className="form-row inline">
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                <legend className="legend-label"><label htmlFor="label-bank-name">{tLang("registration.billing.info.bank-name")}</label>
                                                    <span className="required" title="Mandatory">
                                                        {" "}
                                                        *
                                                    </span>
                                                </legend>
                                            </div>
                                            <div className="col-xs-12 col-sm-8 col-no-gutter">
                                                <div className="row">
                                                    <div className="col-xs-12 col-no-gutter">
                                                        <div className={`form-row row ${errors["bankName"] && "status-error"}`}>
                                                            <div className="form-input col-xs-12 col-no-gutter">
                                                                <input
                                                                    type="text"
                                                                    readOnly={isReadOnly.isBankNameReadOnly}
                                                                    ref={register({ required: true })}
                                                                    className="inputbox"
                                                                    id="label-bank-name"
                                                                    placeholder={tLang("registration.billing.info.bank-name")}
                                                                    name="bankName"
                                                                    defaultValue={eftField.bankName}
                                                                    aria-required="true"
                                                                />
                                                                {errors["bankName"] && errors["bankName"].type === "required" && (
                                                                    <span className="form-error" role="alert">
                                                                        {tLang("registration.billing.info.validations.bank-name-required")}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </fieldset>
                                    <fieldset className="form-row inline">
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                <legend className="legend-label"><label htmlFor="label-routing-number">{tLang("registration.billing.info.routing-number")}</label>
                                                    <span className="required" title="Mandatory">
                                                        {" "}
                                                        *
                                                    </span>
                                                </legend>
                                            </div>
                                            <div className="col-xs-12 col-sm-8 col-no-gutter">
                                                <div className="row">
                                                    <div className="col-xs-12 col-no-gutter">
                                                        <div className={`form-row row ${errors["routingNumber"] && "status-error"}`}>
                                                            <div className="form-input col-xs-12 col-no-gutter">
                                                                {regOptions.routingOptions.length >= 1 ? (
                                                                    <select
                                                                        ref={register({ required: true, validate: (value) => value !== "--" })}
                                                                        name="routingNumber"
                                                                        defaultValue={eftField.routingNumber}
                                                                        className="inputbox"
                                                                        id="label-routing-number"
                                                                        aria-required="true"
                                                                    >
                                                                        <option value="--">--</option>
                                                                        {regOptions.routingOptions.map((value, index) => (
                                                                            <option key={index} value={value}>
                                                                                {value}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                ) : (
                                                                    <input
                                                                        type="text"
                                                                        ref={register({ required: true, pattern: /^(\d{9})|$^[0-9]*$/, maxLength: 9 })}
                                                                        className="inputbox"
                                                                            id="label-routing-number"
                                                                        placeholder={tLang("registration.billing.info.routing-number")}
                                                                        name="routingNumber"
                                                                        defaultValue={eftField.routingNumber}
                                                                        readOnly={isReadOnly.isRoutingReadOnly}
                                                                    />
                                                                )}
                                                                {errors["routingNumber"] && errors["routingNumber"].type === "validate" && (
                                                                    <span className="form-error" role="alert">
                                                                        {tLang("registration.billing.info.validations.routing-number-required")}
                                                                    </span>
                                                                )}
                                                                {errors["routingNumber"] && errors["routingNumber"].type === "required" && (
                                                                    <span className="form-error" role="alert">
                                                                        {tLang("registration.billing.info.validations.routing-number-required")}
                                                                    </span>
                                                                )}
                                                                {errors["routingNumber"] && errors["routingNumber"].type === "pattern" && (
                                                                    <span className="form-error" role="alert">
                                                                        {tLang("registration.billing.info.validations.routing-number-invalid")}
                                                                    </span>
                                                                )}
                                                                {errors["routingNumber"] && errors["routingNumber"].type === "maxLength" && (
                                                                    <span className="form-error" role="alert">
                                                                        {tLang("registration.billing.info.validations.routing-number-invalid-max-length")}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </fieldset>

                                    <fieldset className="form-row inline">
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                <legend className="legend-label"><label htmlFor="label-account-number">{tLang("registration.billing.info.account-number")}</label>
                                                    <span className="required" title="Mandatory">
                                                        {" "}
                                                        *
                                                    </span>
                                                </legend>
                                            </div>
                                            <div className="col-xs-12 col-sm-8 col-no-gutter">
                                                <div className="row">
                                                    <div className="col-xs-12 col-no-gutter">
                                                        <div className={`form-row row ${errors["accountNumber"] && "status-error"}`}>
                                                            <div className="form-input col-xs-12 col-no-gutter">
                                                                <input
                                                                    type="text"
                                                                    maxLength={17}
                                                                    ref={register({ required: true, pattern: /^[0-9]*$^$|^(\d{4,17})$/, maxLength: 17 })}
                                                                    className="inputbox"
                                                                    id="label-account-number"
                                                                    placeholder={tLang("registration.billing.info.account-number")}
                                                                    name="accountNumber"
                                                                    defaultValue={registrationState.billingInfo && registrationState.billingInfo.accountNumber}
                                                                    aria-required="true"
                                                                />
                                                                {errors["accountNumber"] && errors["accountNumber"].type === "required" && (
                                                                    <span className="form-error" role="alert">
                                                                        {tLang("registration.billing.info.validations.account-number-required")}
                                                                    </span>
                                                                )}
                                                                {errors["accountNumber"] && errors["accountNumber"].type === "pattern" && (
                                                                    <span className="form-error" role="alert">
                                                                        {tLang("registration.billing.info.validations.account-number-invalid")}
                                                                    </span>
                                                                )}
                                                                {errors["accountNumber"] && errors["accountNumber"].type === "maxLength" && (
                                                                    <span className="form-error" role="alert">
                                                                        {tLang("registration.billing.info.validations.account-number-invalid")}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </fieldset>
                                    <fieldset className="form-row inline">
                                        <div className="row">
                                            <div className={`form-row inline row}`}>
                                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                                    <label htmlFor="label-account-type">{tLang("registration.billing.info.account-type")}</label>
                                                </div>
                                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                                    <div className="row">
                                                        <div className="col-xs-12 col-no-gutter"></div>
                                                        <div className={`form-row row ${errors["accountType"] && "status-error"}`}>
                                                            <div className="form-input col-xs-12 col-no-gutter">
                                                                {regOptions.accountOptions.length > 1 ? (
                                                                    <select
                                                                        ref={register({ required: true, validate: (value) => value !== "--" })}
                                                                        name="accountType"
                                                                        className="inputbox"
                                                                        id="label-account-type"
                                                                        defaultValue={eftField.accountType}
                                                                    >
                                                                        <option value="">--</option>
                                                                        {regOptions.accountOptions.map((value, index) => (
                                                                            <option key={index} value={value}>
                                                                                {value}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                ) : (
                                                                    <input
                                                                        type="text"
                                                                        ref={register({ required: true })}
                                                                        name="accountType"
                                                                        className="inputbox"
                                                                        id="label-account-type"
                                                                        defaultValue={eftField.accountType}
                                                                        readOnly={isReadOnly.isAccountTypeReadOnly}
                                                                    />
                                                                )}
                                                                {errors["accountType"] &&
                                                                    (errors["accountType"].type === "validate" || errors["accountType"].type === "required") && (
                                                                    <span className="form-error" role="alert">
                                                                            {tLang("registration.billing.info.validations.account-type-required")}
                                                                        </span>
                                                                    )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </fieldset>
                                    <div className="form-row">
                                        <div className="form-input">
                                            <label className="form-checkbox-label">
                                                <input type="checkbox" name="isEFTChecked" onChange={() => checked()} checked={state.isEFTChecked} />
                                                <span className="form-checkbox-label-text">
                                                    {tLang("registration.billing.authorizeTheUseText1")}{" "}
                                                    <span className="default_link" onClick={() => setEFTDialog(true)}>
                                                        <a href="javascript:void(0)" className="default_link">
                                                            {tLang("registration.billing.authorizeTheUseText2")}{" "}
                                                        </a>
                                                    </span>{" "}
                                                    {tLang("registration.billing.authorizeTheUseText3")}
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {!isOnlyEft && state.paymentMethod === "CC" && (
                                <div aria-live="off">
                                    <fieldset className="form-row inline">
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                <legend className="legend-label"><label htmlFor="label_cardholderName">{tLang("registration.billing.info.card-name")}</label>
                                                    <span className="required" title="Mandatory">
                                                        {" "}
                                                        *
                                                    </span>
                                                </legend>
                                            </div>
                                            <div className="col-xs-12 col-sm-8 col-no-gutter">
                                                <div className="row">
                                                    <div className="col-xs-12 col-no-gutter">
                                                        <div className={`form-row row ${errors["cardholderName"] && "status-error"}`}>
                                                            <div className="form-input col-xs-12 col-no-gutter">
                                                                <input
                                                                    type="text"
                                                                    ref={register({ required: true, pattern: PATTERNS.CARDHOLDERNAME.pattern, maxLength: 30 })}
                                                                    className="inputbox"
                                                                    id="label_cardholderName"
                                                                    placeholder={tLang("registration.billing.info.card-name")}
                                                                    name="cardholderName"
                                                                    defaultValue={registrationState.billingInfo && registrationState.billingInfo.cardholderName}
                                                                    aria-required="true"
                                                                />
                                                                {errors["cardholderName"] && errors["cardholderName"].type === "required" && (
                                                                    <span className="form-error" role="alert">
                                                                        {tLang("registration.billing.info.validations.card-name-required")}
                                                                    </span>
                                                                )}
                                                                {errors["cardholderName"] && errors["cardholderName"].type === "pattern" && (
                                                                    <span className="form-error" role="alert">
                                                                        {tLang("registration.billing.info.validations.card-name-invalid")}
                                                                    </span>
                                                                )}
                                                                {errors["cardholderName"] && errors["cardholderName"].type === "maxLength" && (
                                                                    <span className="form-error" role="alert">
                                                                        {tLang("registration.billing.info.validations.card-holder-pattern")}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </fieldset>
                                    <fieldset className="form-row inline">
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                <legend className="legend-label"><label htmlFor="label-cardType">{tLang("registration.billing.info.card-type")}</label>
                                                    <span className="required" title="Mandatory">
                                                        {" "}
                                                        *
                                                    </span>
                                                </legend>
                                            </div>
                                            <div className="col-xs-12 col-sm-8 col-no-gutter">
                                                <div className="row">
                                                    <div className="col-xs-12 col-no-gutter">
                                                        <div className={`form-row row ${errors["cardType"] && "status-error"}`}>
                                                            <div className="form-input col-xs-12 col-no-gutter">
                                                                <select
                                                                    ref={register({ required: true, validate: (value) => value !== "--" })}
                                                                    name="cardType"
                                                                    defaultValue={registrationState.billingInfo && registrationState.billingInfo.cardType}
                                                                    className="inputbox"
                                                                    id="label-cardType"
                                                                    onChange={() => triggerFields()}
                                                                    aria-required="true"
                                                                >
                                                                    <option>--</option>
                                                                    <option value="VISA">Visa</option>
                                                                    <option value="MASTERCARD">MasterCard</option>
                                                                    <option value="AMERICANEXPRESS">American Express</option>
                                                                    <option value="DISCOVER">Discover</option>
                                                                </select>

                                                                {errors && errors["cardType"] && errors["cardType"].type === "validate" && (
                                                                    <span className="form-error" role="alert">
                                                                        <p>{tLang("registration.billing.info.validations.card-type-reruired")}</p>
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </fieldset>

                                    <fieldset className="form-row inline">
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                <legend className="legend-label" > <label htmlFor="label-cardNumber">{tLang("registration.billing.info.card-number")}</label>
                                                    <span className="required" title="Mandatory">
                                                        {" "}
                                                        *
                                                    </span>
                                                </legend>
                                            </div>
                                            <div className="col-xs-12 col-sm-8 col-no-gutter">
                                                <div className="row">
                                                    <div className="col-xs-12 col-no-gutter">
                                                        <div className={`form-row row ${errors["cardNumber"] && "status-error"}`}>
                                                            <div className="form-input col-xs-12 col-no-gutter">
                                                                <input
                                                                    type="text"
                                                                    ref={register({ required: true, validate: validation })}
                                                                    className="inputbox"
                                                                    id="label-cardNumber"
                                                                    placeholder={tLang("registration.billing.info.card-number")}
                                                                    name="cardNumber"
                                                                    maxLength={20}
                                                                    defaultValue={registrationState.billingInfo && registrationState.billingInfo.cardNumber}
                                                                    aria-required="true"
                                                                />

                                                                {errors["cardNumber"] && errors["cardNumber"].type === "required" && (
                                                                    <span className="form-error" role="alert">
                                                                        {tLang("registration.billing.info.validations.card-number-required")}
                                                                    </span>
                                                                )}
                                                                {errors["cardNumber"] && errors["cardNumber"].type === "invalid" && (
                                                                    <span className="form-error" role="alert">
                                                                        {tLang("registration.billing.info.validations.card-number-invalid")}
                                                                    </span>
                                                                )}
                                                                {/*  {errors['cardNumber'] && errors['cardNumber'].type === "invalid" &&
                                                                    (<span className="form-error">Card Number must be less than 20 characters length.</span>)} */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </fieldset>

                                    <fieldset className="form-row inline">
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                <legend className="legend-label"><label htmlFor="expirationDate">{tLang("registration.billing.info.expiry-date")}</label>
                                                    <span className="required" title="Mandatory">
                                                        {" "}
                                                        *
                                                    </span>
                                                </legend>
                                            </div>
                                            <div className="col-xs-12 col-sm-8 col-no-gutter">
                                                <div className="row">
                                                    <div className="col-xs-12 col-no-gutter">
                                                        <div className={`form-row row ${errors["expirationDate"] && "status-error"}`}>
                                                            <div className="form-input col-xs-12 col-no-gutter">
                                                                    <input name="expirationDate" id="expirationDate" type="text" onKeyDown={keyCode} onChange={addMask}
                                                                    className="inputbox"
                                                                    defaultValue={
                                                                        registrationState.billingInfo.expirationDate && registrationState.billingInfo.expirationDate
                                                                    }
                                                                    ref={register({
                                                                        required: true,
                                                                        maxLength: 5,
                                                                        pattern: /(0[1-9]|1[012])[/]?([0-9][1-9]|[1-9][0-9])/,
                                                                        validate: (value) => {
                                                                            if (value.length === 5) {
                                                                                const expireDate = value.split("/");
                                                                                return validateCardExpiry(expireDate[0], expireDate[1]);
                                                                            }
                                                                            return true;
                                                                        },
                                                                    })}
                                                                    aria-required="true"
                                                                    placeholder="MM/YY"
                                                                    maxLength={5}
                                                                />
                                                                {renderError(
                                                                    "expirationDate",
                                                                    "required",
                                                                    tLang("registration.billing.info.validations.card-expdate-required")
                                                                )}
                                                                {renderError(
                                                                    "expirationDate",
                                                                    "pattern",
                                                                    tLang("registration.billing.info.validations.card-expdate-invalid")
                                                                )}
                                                                {renderError(
                                                                    "expirationDate",
                                                                    "validate",
                                                                    `${tLang(
                                                                        "registration.billing.info.validations.card-expdate-invalid-date"
                                                                    )} ${partnerPhoneNumber}.`
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </fieldset>

                                    <fieldset className="form-row inline">
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                <legend className="legend-label"><label htmlFor="label-securityCode">{tLang("registration.billing.info.code")}</label>
                                                    <span className="required" title="Mandatory">
                                                        {" "}
                                                        *
                                                    </span>
                                                </legend>
                                            </div>
                                            <div className="col-xs-12 col-sm-8 col-no-gutter">
                                                <div className="row">
                                                    <div className="col-xs-12 col-no-gutter">
                                                        <div className={`form-row row ${errors["securityCode"] && "status-error"}`}>
                                                            <div className="form-input col-xs-12 col-no-gutter">
                                                                <input
                                                                    type="password"
                                                                    maxLength={watchCardType === "AMERICANEXPRESS" ? 4 : 3}
                                                                    ref={register({ required: true, validate: validationCode })}
                                                                    className="inputbox"
                                                                    id="label-securityCode"
                                                                    placeholder="CVV"
                                                                    name="securityCode"
                                                                    defaultValue={
                                                                        registrationState.billingInfo.securityCode && registrationState.billingInfo.securityCode
                                                                    }
                                                                    aria-required="true"
                                                                />
                                                                {errors["securityCode"] && errors["securityCode"].type === "required" && (
                                                                    <span className="form-error" role="alert">
                                                                        {tLang("registration.billing.info.validations.security-code-required")}
                                                                    </span>
                                                                )}
                                                                {errors["securityCode"] && errors["securityCode"].type === "invalid" && (
                                                                    <span className="form-error" role="alert">
                                                                        {tLang("registration.billing.info.validations.security-code-invalid")}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </fieldset>
                                </div>
                            )}
                            <div className="margin-bottom-l"></div>
                            <hr />
                            <div className="margin-bottom-l"></div>
                            <BillingAddress
                                registrationState={registrationState}
                                billingState={state}
                                register={register}
                                errors={errors}
                                setBillingState={setState}
                                handleStateChange={handleStateChange}
                                displayData={displayData}
                            />
                            <hr />
                            <div className="margin-bottom-l"></div>
                            <div className="box-header">
                                <div className="box-title-container">
                                    <div className="box-title-text">
                                        <h2 className="box-title"> {selectedCycle === "annual" ? tLang("registration.billing.renewal-disclosure.yearly-automatic-renewal") : tLang("registration.billing.renewal-disclosure.monthly-automatic-renewal")}</h2>
                                    </div>
                                </div>
                            </div>
                            <div className="margin-bottom-l"></div>
                            <div className="form-row">
                                <div className="form-input">
                                    <label className="form-checkbox-label">
                                        <input
                                            type="checkbox"
                                            name="isTermsChecked"
                                            onClick={onAutoRenewalCheckBox}
                                            onChange={() => checkedTerms()}
                                            checked={state.isTermsChecked}
                                        />
                                        {((Gndrll && Gndrll.includes('PSS') && !IsWhiteLabeled && displayData.billingRequired) || (LookupType == "SSSOFFER" || LookupType == "WALKUP")) ? (
                                            <>
                                                <span className="form-checkbox-label-text" style={{ lineHeight: "1.5rem",paddingTop:"0.3rem" }}>
                                                    {tLang("registration.billing.renewal-disclosure.renewalText1")}
                                                    {price} {tLang("registration.billing.renewal-disclosure.renewalText2")} {" "} {selectedCycle === "annual" ? tLang("registration.billing.renewal-disclosure.an-annual") : tLang("registration.billing.renewal-disclosure.a-monthly")}{" "}
                                                    {tLang("registration.billing.renewal-disclosure.renewalText3")}
                                                    {price} {tLang("registration.billing.renewal-disclosure.renewalText4")} {" "}
                                                    {selectedCycle === "annual" ? tLang("registration.billing.renewal-disclosure.year") : tLang("registration.billing.renewal-disclosure.month")} {" "}
                                                    {tLang("registration.billing.renewal-disclosure.renewalText5")} {" "}
                                                    {selectedCycle === "annual" ? tLang("registration.billing.renewal-disclosure.annual") : tLang("registration.billing.renewal-disclosure.monthly")} {tLang("registration.billing.renewal-disclosure.renewalText6")} {" "} {selectedCycle === "annual" ? "date " : "day "}
                                                    {tLang("registration.billing.renewal-disclosure.renewalText7")} {" "}
                                                    {selectedCycle === "annual" ? tLang("registration.billing.renewal-disclosure.year") : tLang("registration.billing.renewal-disclosure.month")} {tLang("registration.billing.renewal-disclosure.renewalText8")} {" "}
                                                    <div className="margin-bottom-l"></div>
                                                    <legend className="legend-label">{tLang("registration.billing.renewal-disclosure.cancellation")}</legend>
                                                    {tLang("registration.billing.renewal-disclosure.renewalText9")} {" "} {partnerPhoneNumber}.
                                                    {tLang("registration.billing.renewal-disclosure.renewalText10")} {" "}
                                                </span>
                                            </>
                                        ) : (
                                            <>
                                                <span className="form-checkbox-label-text" style={{ lineHeight: "1.5rem" }}>
                                                    {state.TermsData.content && parse(state.TermsData.content[0].value, options)}
                                                </span>
                                            </>)
                                        }
                                    </label>
                                </div>
                            </div>
                        </div>
                        <Cart
                            registrationLookup={registrationLookup}
                            displayData={displayData}
                            registrationState={registrationState}
                            setRegistrationState={setRegistrationState}
                            saleTaxValue={saleTaxValue}
                            annualSalesTaxValue={annualSalesTaxValue}
                            selectedCountry={registrationState.addressInfo.country}
                            creditDisclosureText={creditDisclosureText}
                            getproductServiceType={getproductServiceType}
                            NonCreditServiceType={NonCreditServiceType}
                        />
                    </div>
                    <div className="margin-vertical-l"></div>

                    <div className="row between-xs">
                        <div className="col-xs col-no-gutter flex-grow-null"></div>
                        <div className="col-xs col-no-gutter flex-grow-null">
                            <ul className="list-inline list-reset">
                                <li className="margin-left-s">
                                    <button
                                        type="button"
                                        className="btn-default
                                                    btn-default btn-min-width"
                                        onClick={() => setPrevious()}
                                    >
                                        <span className="btn-text">{isPreviousOrBack}</span>
                                    </button>
                                </li>
                                <li className="margin-left-s">
                                    <button
                                        type="submit"
                                        onClick={onBillingInfoNext}
                                        disabled={isDisabled()}
                                        className="btn-default btn-primary btn-min-width"
                                    >
                                        <span className="btn-text">{tLang("registration.billing.agree-btn")}</span>
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </form>
            </div>
            {EFTdialog && (
                <DialogComponent dialogId="eft" title="Your cart" closeDialog={handleCloseEFTDialog}>
                    <EFTDialog data={state.EFTData}></EFTDialog>
                </DialogComponent>
            )}
            {Termsdialog && (
                <DialogComponent bodyClass="dialog-content width-lg" dialogId="termsDialog" title="Your cart" closeDialog={handleCloseTermsDialog}>
                    <TermsAndConditionDialog data={state.TermsData} /* handleClose={handleCloseTermsDialog} */></TermsAndConditionDialog>
                </DialogComponent>
            )}
        </>
    );
};

export default BillingInformation;
